"use client";

import Image from "next/image";
import { HomeHeroSearchBar, HomeHeroSearchBarDto } from "./home-hero-search-bar";
import { HeaderSearchBarScrollObserver } from "@shared/ui";
import { THomeHeroSection } from "@shared/cms";
import { transformQueryParamsWithoutLocale } from "@shared/utils";
import { useRouter } from "next/navigation";

export function HomeHeroSection({
  title,
  subtitle,
  leftBannerDesktop,
  leftBannerMobile,
  rightBannerDesktop,
  rightBannerMobile,
  searchbar,
}: THomeHeroSection) {
  const router = useRouter();

  const handleSearch = (payload: HomeHeroSearchBarDto) => {
    const path = transformQueryParamsWithoutLocale("/lowongan-dalam-negeri/lowongan", {
      skills: payload.skill
        ? [
            {
              id: payload.skill.value,
              label: payload.skill.label,
            },
          ]
        : null,
      locations: payload.location
        ? [
            {
              id: payload.location.value,
              label: payload.location.label,
              type: payload.location.type,
            },
          ]
        : null,
    });

    router.push(path);
  };

  return (
    <>
      <section className="relative pt-10 pb-14 sm:pt-[120px]">
        <div className="hidden sm:block">
          {leftBannerDesktop && (
            <Image
              src={leftBannerDesktop.url}
              className="w-[296px] md:w-[408px] absolute left-0 top-5 object-cover"
              alt={leftBannerDesktop.alternativeText || leftBannerDesktop.name || "Karirhub Hero"}
              width={leftBannerDesktop.width || 974}
              height={leftBannerDesktop.height || 1064}
            />
          )}
          {rightBannerDesktop && (
            <Image
              src={rightBannerDesktop.url}
              className="w-[456px] md:w-[650px] absolute right-0 top-5 object-cover"
              alt={rightBannerDesktop.alternativeText || rightBannerDesktop.name || "Karirhub Hero"}
              width={rightBannerDesktop.width || 1290}
              height={rightBannerDesktop.height || 1084}
            />
          )}
        </div>
        <div className="sm:hidden">
          {leftBannerMobile && (
            <Image
              src={leftBannerMobile.url}
              alt={leftBannerMobile.alternativeText || leftBannerMobile.name || "Karirhub Hero"}
              className="absolute -left-14 bottom-[120px] object-cover"
              style={{ width: "135.54px" }}
              width={leftBannerMobile.width || 224}
              height={leftBannerMobile.height || 312}
            />
          )}
          {rightBannerMobile && (
            <Image
              src={rightBannerMobile.url}
              alt={rightBannerMobile.alternativeText || rightBannerMobile.name || "Karirhub Hero"}
              className="absolute right-0 top-0 object-cover"
              style={{ width: "135.54px" }}
              width={rightBannerMobile.width || 212}
              height={rightBannerMobile.height || 58}
            />
          )}
        </div>
        <div className="container relative">
          <div className="text-center mb-14">
            {subtitle && <h1 className="text-xs font-medium text-primary bg-primary-50 px-4 py-1 rounded-full inline-block">{subtitle}</h1>}
            {title && (
              <div className="mt-6 mx-auto max-w-[602px]">
                <h2 className="mb-4 text-gray-700 text-4xl sm:text-5xl font-bold !leading-[120%]">{title}</h2>
              </div>
            )}
          </div>
          <div id="heroSearchBar">{searchbar && <HomeHeroSearchBar {...searchbar} onSubmit={handleSearch} />}</div>
        </div>
      </section>
      <HeaderSearchBarScrollObserver targetElement="#heroSearchBar" />
    </>
  );
}
